import React, { useState } from 'react';
import { deleteReasonTexts, } from '@debbie/common/dist/customers/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import * as debtRegisterAPI from '@debbie/cortex/dist/api/debt-register.js';
import { Button, Modal, Select } from '../index.js';
const DeleteModal = (props) => {
    const [deleting, setDeleting] = useState(false);
    const [deleteReason, setDeleteReason] = useState(null);
    return (React.createElement(Modal, { header: "Slet RKI-registrering", onToggle: props.toggleDeleteModal, maxWidth: "350px" },
        React.createElement(Select, { onChange: (e) => setDeleteReason(e.target.value), value: deleteReason },
            React.createElement("option", { value: "" }, "- V\u00E6lg \u00E5rsag -"),
            Object.entries(deleteReasonTexts).map((e) => (React.createElement("option", { key: e[0], value: e[0] }, e[1])))),
        React.createElement(Button, { disabled: !deleteReason, loading: deleting, block: true, onClick: async () => {
                try {
                    setDeleting(true);
                    if (!props.userId)
                        throw new Error('Ingen debitor valgt.');
                    if (!deleteReason)
                        throw new Error('Ingen sletteårsag valgt');
                    if (!props.rkiReferenceId)
                        throw new Error('Intet rkiReferenceId valgt.');
                    await debtRegisterAPI.rkiDelete(props.userId, props.case.caseId, props.rkiReferenceId, deleteReason);
                    await c.cases.getById(props.case.id);
                    await c.customers.getById(props.customer.customerId);
                    props.toggleDeleteModal();
                }
                catch (error) {
                    console.error(error);
                    const err = error?.message ? JSON.parse(error.message) : error;
                    alert(err.description || err);
                }
                setDeleting(false);
            } }, "Slet RKI-registrering")));
};
export default DeleteModal;
//# sourceMappingURL=DeleteModal.js.map